<span
  class="menuitems"
  (click)="handleClick()"
  [ngClass]="{ hastext: hasDisplayText }"
>
  <ion-icon class="sidebar-icon" [ngClass]="{ active: isActive }" [src]="icon">
  </ion-icon>
  @if (hasDisplayText) {
    <span [ngClass]="{ active: isActive }" class="main-label">
      {{ displayText }}
    </span>
  }
</span>
